import KendoColorPickerMixin from './KendoColorPickerMixin'

export default {
    name: 'kendo-colorpicker',
    mixins: [ KendoColorPickerMixin ]
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/KendoColorPicker/index.js